import React from 'react'
import {TablePagination} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import {getPaginationConfig} from "hooks/useSearch";

function Pagination(
    {
        config = getPaginationConfig(1, 10),
        setConfig = () => {
        },
        rowsPerPageOptions = [1, 2, 5, 10, 25, 50],
        totalCount = 0,
        disabled
    }) {

    const handleChangePage = (event, newPage) => {
        setConfig({...config, page: newPage + 1});
    }

    const handleChangeRowsPerPage = (event) => {
        setConfig({...config, page: 1, pageSize: parseInt(event.target.value, 10)});
    }

    return (
        <TablePagination
            component="div"
            rowsPerPageOptions={rowsPerPageOptions}
            count={totalCount}
            rowsPerPage={config.pageSize}
            page={config.page - 1}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={Tr('rows_per_page')}
            labelDisplayedRows={({from, to, count}) => `${from}-${to === -1 ? count : to} ${Tr('of')} ${count}`}
            SelectProps={{
                disabled: disabled
            }}
            backIconButtonProps={
                disabled
                    ? {
                        disabled: disabled
                    }
                    : undefined
            }
            nextIconButtonProps={
                disabled
                    ? {
                        disabled: disabled
                    }
                    : undefined
            }
        />
    )
}

Pagination.propTypes = {
    config: PropTypes.shape({
        page: PropTypes.number,
        pageSize: PropTypes.number
    }),
    setConfig: PropTypes.func,
    rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
    totalCount: PropTypes.number,
    disabled: PropTypes.bool
}

export default Pagination;